import SmoothScroll from "@/components/SmoothScroll";
import Nav from "@/components/marketing/Nav";
import Hero from "@/components/marketing/Hero";
import Approach from "@/components/marketing/Approach";
import EditorialMarquee from "@/components/marketing/Marquee";
import Services from "@/components/marketing/Services";
import Contact from "@/components/marketing/Contact";
import Footer from "@/components/marketing/Footer";

export default function Landing() {
  return (
    <SmoothScroll>
      <div className="grain relative bg-background" data-testid="landing-page">
        <Nav />
        <main>
          <Hero />
          <Approach />
          <EditorialMarquee />
          <Services />
          <Contact />
        </main>
        <Footer />
      </div>
    </SmoothScroll>
  );
}
